module.exports = __webpack_public_path__ + "static/media/NoteTaker.43fa5a74.png";